module.exports = __webpack_public_path__ + "static/deloitte_homepage-564fb0bf2b0bf566704c38bbcdaea96c.jpg";